var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.value,"content-class":_vm.contentClass,"width":_vm.width},on:{"input":args => _vm.$emit('input', args)}},[_c('v-card',[_c('div',{class:_vm.b('content')},[_c('div',{class:_vm.b('title')},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }